import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTenantBilling } from "../../../store/authSlice";
import { hasAdminAccess, isClubStaff } from "../../../utils/roles";
import { useActivation } from "../../../activation";
import { useTrainingMode } from "../../../training";
import ClubSubscriptionInlineBanner from "../../common/ClubSubscription/ClubSubscriptionInlineBanner";

export default function SubscriptionGate({
  children,
  profilePath = "/manage/app/profile/account/billing",
}) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { visible: activationActive, allDone: activationDone } = useActivation();
  const { active: trainingActive } = useTrainingMode();
  const { isAuth, role, billing, billingLoad, tenant } = useSelector(
    (state) => state.auth,
  );
  const isStaff = isAuth && isClubStaff(role);
  const canPay = hasAdminAccess(role);
  const onBillingPage =
    pathname === profilePath ||
    pathname.includes("/profile/account/billing") ||
    pathname.endsWith("/account/billing");
  const onboardingInProgress = activationActive && !activationDone;

  useEffect(() => {
    if (isStaff && hasAdminAccess(role)) {
      dispatch(fetchTenantBilling());
    }
  }, [isStaff, role, dispatch]);

  const showUnpaidBanner =
    isStaff &&
    !billingLoad &&
    billing != null &&
    (!billing.is_paid || billing.is_demo_expired) &&
    !billing.is_trial &&
    !onboardingInProgress &&
    !trainingActive &&
    !onBillingPage;

  return (
    <>
      {showUnpaidBanner ? (
        <ClubSubscriptionInlineBanner
          billing={billing}
          clubName={tenant?.name || billing?.club_name}
          profilePath={profilePath}
          showCta={canPay}
          ctaLabel={canPay ? "Оплатить тариф" : "Подробнее"}
        />
      ) : null}
      {children}
    </>
  );
}
